import { BookingHeader } from '../../booking/BookingParts';
import { useFormHorarioClienteContext } from './Context';

export const AgendaFormHeader = ({ step, hideBackOnMobile }: { step: string; hideBackOnMobile: boolean }) => {
    const { atendente, servico, servicosExtras, attendantCount, lockAtendente, canStepBack, stepBack, loading, doc } =
        useFormHorarioClienteContext();

    const titles: Record<string, string> = {
        atendente: 'Escolha o profissional',
        servico: 'Escolha os serviços',
        horario: 'Escolha o dia e o horário',
        confirm: doc?._id ? 'Revise as alterações' : 'Cliente e confirmação',
    };
    // So contam as etapas em que ha o que escolher.
    const steps = [attendantCount !== 1 && !lockAtendente && 'atendente', 'servico', 'horario', 'confirm'].filter(Boolean) as string[];
    const recap = [
        atendente?.displayName ? `Com ${atendente.displayName}` : '',
        step !== 'servico' && servico?.name
            ? [servico.name, ...servicosExtras.map((extra: any) => extra?.name)].filter(Boolean).join(' + ')
            : '',
    ].filter(Boolean);

    return (
        <BookingHeader
            steps={steps}
            step={step}
            title={titles[step]}
            recap={step !== 'confirm' ? recap.join(' · ') : ''}
            canStepBack={canStepBack}
            onBack={stepBack}
            loading={loading}
            hideBackOnMobile={hideBackOnMobile}
        />
    );
};
